import type { ReactNode } from 'react'
import { Typography } from '@/components/ui/typography'

export function SectionHeader({
  title,
  afterTitle,
  right,
}: {
  title: string
  afterTitle?: ReactNode
  right?: ReactNode
}) {
  return (
    <div className="flex flex-col items-start gap-1 rounded-sm bg-primary/8 px-3 py-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-2">
      <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5 sm:items-center">
        <Typography variant="section-title" className="text-primary/80">
          {title}
        </Typography>
        {afterTitle}
      </div>
      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  )
}
